<script setup>
import axios from "axios";
import { ref, reactive, onMounted, watch } from "vue";
import {
  getOpKnowledgeBaseCategoryTreeApi,
  saveOpKnowledgeBaseCategoryApi,
  updateOpKnowledgeBaseCategoryApi,
  getOpKnowledgeBaseCategoryApi,
  deleteOpKnowledgeBaseCategoryApi,
  resortOpKnowledgeBaseCategoryApi,
} from "@/api/directory";
import { ElMessage, ElMessageBox } from "element-plus";

// 页面title
const title = ref("目录维护");

// 树遮罩
const treeLoading = ref(false);

// 表单遮罩
const loading = ref(false);

//显示表单
const showForm = ref(false);

//禁用表单
const formDisabled = ref(false);

//显示父节点
const showParentName = ref(true);

//显示按钮
const showBottom = ref(false);

//新增编辑
const saveType = ref("add");

// 表单数据
const formData = reactive({
  name: null,
  parentId: null,
  parentName: null,
  id: null,
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "请输入目录名称", trigger: "blur" }],
});

// 表单ref
const ruleRef = ref(null);

// 树props
const defaultProps = reactive({
  label: "name",
  children: "childNodes",
});

// 区域树
const treeData = ref([]);

//树搜索
const filterText = ref("");

//树ref
const treeRef = ref(null);

// 描述列表对象
const descriptionData = reactive({
  name: null,
  areaType: null,
  logo: null,
});

// 获取树
const getDirectoryTree = () => {
  treeLoading.value = true;
  getOpKnowledgeBaseCategoryTreeApi()
    .then((res) => {
      treeData.value = res.data;
    })
    .finally(() => {
      treeLoading.value = false;
    });
};

// 树点击操作
const handleNodeClick = (data) => {
  showForm.value = true;
  showBottom.value = false;
  showParentName.value = false;
  formDisabled.value = true;
  ruleRef.value?.resetFields();
  formData.name = data.name;
};

// 获取字典数据
const getLocationType = () => {};

// 通过字典类型获取字典数据
const getDicNameByValue = (key) => {};

//新增根节点
const handleAddRootNode = () => {
  showForm.value = true;
  formDisabled.value = false;
  showBottom.value = true;
  showParentName.value = false;
  ruleRef.value?.resetFields();
  formData.parentId = 0;
  formData.name = "";
};

// 点击新增或者编辑
const handleLocationAdjust = (node, data, type) => {
  showForm.value = true;
  formDisabled.value = false;
  showBottom.value = true;
  ruleRef.value?.resetFields();
  if (type == "add") {
    showParentName.value = true;
    formData.name = null;
    formData.id = null;
    formData.parentId = data.id;
    formData.parentName = data.name;
  } else {
    showParentName.value = false;
    formData.parentId = null;
    formData.name = data.name;
    formData.id = data.id;
  }
  saveType.value = type;
};

//点击保存
const handleAdd = () => {
  const submitApi =
    saveType.value == "add"
      ? saveOpKnowledgeBaseCategoryApi
      : updateOpKnowledgeBaseCategoryApi;
  loading.value = true;
  submitApi(formData)
    .then((res) => {
      if (res.code == 2000) {
        ElMessage.success("操作成功");
        getDirectoryTree();
        showForm.value = false;
        showBottom.value = false;
      }
    })
    .finally(() => {
      loading.value = false;
    });
  // }
};

// 点击删除
const handleLocationDelete = (row) => {
  ElMessageBox.confirm(`是否确认删除名称为"${row.name}"的目录?`, "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      deleteOpKnowledgeBaseCategoryApi(row.id)
        .then((res) => {
          if (res.code == 2000) {
            ElMessage.success("操作成功");
            getDirectoryTree();
          }
        })
        .finally(() => {
          loading.value = false;
        });
    })
    .catch(() => {});
};

//搜索树
const searchTree = () => {};

// 树节点筛选
const filterNode = (value, data) => {
  console.log(data);
  if (!value) return true;
  return data.name.indexOf(value) !== -1;
};

//拖拽逻辑
const dropAllow = (draggingNode, dropNode, type) => {
  if (draggingNode.data.id === dropNode.data.id) {
    return type === "prev" || type === "next";
  } else {
    return type === "prev" || type === "next" || type === "inner";
  }
};

watch([() => filterText.value], ([newText]) => {
  treeRef.value.filter(newText);
});

//树拖拽成功调用
const dragSuccess = (draggingNode, dropNode, type) => {
  resortOpKnowledgeBaseCategoryApi(treeData.value)
    .then((res) => {
      if (res.code == 2000) {
        ElMessage.success("操作成功");
        getDirectoryTree();
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

onMounted(async () => {
  getDirectoryTree();
});
</script>

<template>
  <zh-layout v-bind="{ title }">
    <template #header-btn>
      <el-button
        type="primary"
        @click="handleAdd(null, true, typeTree)"
        v-if="showBottom"
      >
        保存
      </el-button>
    </template>
    <div class="layout_content">
      <div class="left_content">
        <div style="display: flex">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model.trim="filterText"
            clearable
          />
          <el-button
            type="text"
            style="margin-left: 10px"
            @click="handleAddRootNode"
            >新增</el-button
          >
        </div>
        <el-tree
          ref="treeRef"
          :data="treeData"
          node-key="id"
          default-expand-all
          :props="defaultProps"
          :expand-on-click-node="false"
          :highlight-current="true"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          :current-node-key="treeData[0]?.id"
          draggable
          :allow-drop="dropAllow"
          @node-drop="dragSuccess"
        >
          <template #default="{ node, data }">
            <span class="custom-tree-node">
              <span class="labelCss">{{ node.label }}</span>
              <span class="btn">
                <el-icon @click.stop="handleLocationAdjust(node, data, 'add')"
                  ><CirclePlusFilled color="#409EFF"
                /></el-icon>
                <el-icon @click.stop="handleLocationAdjust(node, data, 'edit')"
                  ><EditPen color="#67C23A"
                /></el-icon>
                <el-icon @click.stop="handleLocationDelete(data)"
                  ><DeleteFilled color="#F56C6C"
                /></el-icon>
              </span>
            </span>
          </template>
        </el-tree>
      </div>
      <div class="right_content">
        <el-form
          ref="ruleRef"
          :model="formData"
          :rules="rules"
          v-loading="loading"
          label-width="120px"
          label-position="top"
          v-if="showForm"
        >
          <el-row v-if="showParentName">
            <el-col :span="20" :offset="1">
              <el-form-item label="父目录" prop="parentName">
                <el-input v-model="formData.parentName" :disabled="true" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20" :offset="1">
              <el-form-item label="目录名称" prop="name">
                <el-input
                  v-model="formData.name"
                  placeholder="请输入目录名称"
                  :disabled="formDisabled"
                  maxlength="128"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </zh-layout>
</template>

<style lang="scss" scoped>
.layout_content {
  display: flex;
  width: 100%;
  height: 100%;
  .left_content {
    width: 320px;
    height: calc(100% - 20px);
    padding: 10px;
    overflow: auto;
    background-color: #fff;
  }
  .right_content {
    width: calc(100% - 300px);
    margin-left: 10px;
    padding-top: 20px;
    background-color: #fff;
    height: 100%;
    height: calc(100% - 20px);
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .btn {
    width: 60px;
    display: flex;
    justify-content: space-between;
  }
  .labelCss {
    width: 165px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
